import { LINKS } from 'utils/constant';

const { Images } = require('assets/images');

export const icons = [{
  img: Images.facebookIconBlueGreen,
  link: LINKS.FACEBOOK,
},
{
  img: Images.instagramIconBlueGreen,
  link: LINKS.INSTAGRAM,
},
{
  img: Images.twitterIconBlueGreen,
  link: LINKS.TWITTER,
},
{
  img: Images.linkedinIconBlueGreen,
  link: LINKS.LINKEDIN,
},
];

export const contacts = [
  {
    icon: Images.letter,
    content: 'info@itah.ai',
  },
  {
    icon: Images.geolocation,
    content: 'Yerevan, Armenia',
  },
  {
    icon: Images.phoneDark,
    content: '+374 99 95 95 95',
  },
];
